import { getApexDomain } from './get-apex-domain';

const BASE_URL_HOSTNAME = process.env.REACT_APP_BASE_URL ? new URL(process.env.REACT_APP_BASE_URL).hostname : '';

export const replaceApexDomainForCurrentHost = (host: string) => {
	const currentApexDomain = getApexDomain(window.location.hostname);

	if (currentApexDomain === 'localhost') {
		return host;
	}

	return host.replace(BASE_URL_HOSTNAME, currentApexDomain);
};

export const API_HOST = replaceApexDomainForCurrentHost(process.env.REACT_APP_API_HOST || '');
export const METRICS_HOST = replaceApexDomainForCurrentHost(process.env.REACT_APP_METRICS_API_HOST || '');
export const TRANSLATIONS_SERVICE_HOST = replaceApexDomainForCurrentHost(process.env.REACT_APP_TRANSLATIONS_SERVICE_HOST || '');
